import React, { Component } from "react";
// import {Link} from 'react-router-dom'
import "bootstrap/dist/css/bootstrap.css";
import "mdbreact/dist/css/mdb.css";
import { MDBCard, MDBCardBody, MDBRow, MDBCol, MDBCardTitle } from "mdbreact";
import ReactHTMLParser from "react-html-parser";

import content from "../Helpers/home-content-data";
import ShowMoreText from "react-show-more-text";

class HomeCardDeck extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let cards = content.items.map((item, key) => {
      return (
        <MDBCol md="4"  key={key} style={{margin:"2px"}}>
          <MDBCard>
            <MDBCardTitle style={{ padding: "10px" }}>
              {ReactHTMLParser(item.caption)}
            </MDBCardTitle>
            <MDBCardBody style={{ height: "150px" }}>
              {/* <MDBCardText style={{textAlign:"justify"}}> */}

              <ShowMoreText
                lines={4}
                more="Show more"
                less="Show less"
                anchorClass=""
                onClick={this.executeOnClick}
                expanded={false}
              >
                {" "}
                <p style={{ textAlign: "justify" }}>
                  {ReactHTMLParser(item.description)}
                </p>
              </ShowMoreText>
              {/* </MDBCardText> */}
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      );
    });
    return (
      <div style={{ padding: "10px" }}>
        <MDBRow center>{cards}</MDBRow>
      </div>
    );
  }
}

export default HomeCardDeck;
